module.exports = "<app-product-list categoryId=\"Oferta2\"></app-product-list>\r\n"